// extracted by mini-css-extract-plugin
export var dropdownContainer = "_sf-0";
export var leftAlign = "_sf-4";
export var listItem = "_sf-2";
export var listItemWrapper = "_sf-1";
export var operationText = "_sf-3";